import { Language } from "@/hooks/use-browser-language";

type TranslationKey = "title";

const translations: Record<Language, Record<TranslationKey, string>> = {
  pl: {
    title: "Polityka plików cookie",
  },
  en: {
    title: "Cookie Policy",
  },
};

export function getCookieTranslation(language: Language, key: TranslationKey): string {
  return translations[language][key] || translations.en[key];
}
